import { useFormContext } from 'react-hook-form';

import { PayrollModelId } from '@xemplo/gp-types';
import { InlineBanner, InlineBannerType } from '@xemplo/inline-banner';

import { getMilestoneFields } from '../edit-payrun-milestones.const';
import { MilestoneFormValues } from '../edit-payrun-milestones.types';

import { getWeekendMilestones } from './milestone-validation';

export interface WeekendWarningBannerProps {
  payrollModelId: PayrollModelId;
}

/**
 * Live, non-blocking warning for milestones that land on a weekend. Watches
 * the form so it appears as the user edits, before they choose to save. Scoped
 * to the fields visible for the payroll model so hidden milestones never warn.
 */
export function WeekendWarningBanner({
  payrollModelId,
}: Readonly<WeekendWarningBannerProps>) {
  const { watch } = useFormContext<MilestoneFormValues>();
  const formValues = watch();
  const labels = getWeekendMilestones(formValues, getMilestoneFields(payrollModelId));
  if (labels.length === 0) return null;

  return <InlineBanner type={InlineBannerType.Warning} title={buildMessage(labels)} />;
}

export function buildMessage(labels: string[]): string {
  const verb = labels.length === 1 ? 'falls' : 'fall';
  const list =
    labels.length === 1
      ? labels[0]
      : `${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}`;
  return `${list} ${verb} on a weekend`;
}
